<template>
  <div v-if="display">
    <WellsBadges
      v-if="type === 'wells'"
      :is_on_sale="is_on_sale"
      :is_new="is_new"
      :is_top="is_top"
      :is_out_of_stock="is_out_of_stock"
      :discount_percentage="discount_percentage"
    ></WellsBadges>
  </div>
</template>

<script>
import WellsBadges from '@/components/general-ui/badges/Wells.vue';

export default {
  name: 'Badges',
  components: {
    WellsBadges,
  },
  props: {
    is_on_sale: {
      type: Boolean,
      default() {
        return false
      }
    },
    is_new: {
      type: Boolean,
      default() {
        return false
      }
    },
    is_top: {
      type: Boolean,
      default() {
        return false
      }
    },
    is_out_of_stock: {
      type: Boolean,
      default() {
        return false
      }
    },
    discount_percentage: {
      type: Number,
      default() {
        return 0;
      }
    },
  },
  data() {
    return {
      type: ws_vue_store.config.badges,
      display: ws_vue_store.use_badges === "1"
    };
  },
  methods: {
  },
};
</script>
